export default __webpack_public_path__ + "static/media/clouds.1fc3690f.png";